import {Component, OnDestroy, OnInit} from '@angular/core';
import {
	ForgetPasscodeTimelinesViaPhonenumber,
	ForgetPasscodeTimelinesViaPhonenumber2FAOrderByLiveliness,
	ForgetPasscodeTimelinesViaPhonenumber2FAOrderByOTP,
	ForgetPasscodeTimelinesViaUsername,
	ForgetPasscodeTimelinesViaUsername2FAOrderByLiveliness,
	ForgetPasscodeTimelinesViaUsername2FAOrderByOTP,
	LoginTypeRequest,
	PasscodeRecoveryStep,
  PasscodeRecoveryStep2FAOrderByLiveliness,
  PasscodeRecoveryStep2FAOrderByOTP
} from "@app/channels/auth/login/model/forget-passcode";
import {ScreenManagerService} from "@mpt-fo/common/core/services/screen-manager.service";
import {SettingsService} from "@mpt-fo/common/core/services/settings.service";
import {OnboardingV2Service} from "@mpt-fo/common/core/services/onboarding-v2.service";
import {StringHelper} from "@mpt-fo/common/core/helpers/strings.helper";
import {TimelineModel} from "@mpt-fo/common/shared/models/timeline.model";
import {
	BtnType,
	CustomTimelineVersion,
	IconType,
	IdentityProvider, OtpResentMode,
	SmileIdImage,
	SmileIdPayload,
} from "@mpt-fo/common/kamona/model/kamonal-model";
import {ModalOptionsConfig, ModalService} from "@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service";
import {HIDE_ANT_MODAL_CLASS} from "@mpt-fo/common/shared/constants";
import {NzModalRef} from "ng-zorro-antd/modal";
import {
	KamonaProgressModalComponent
} from "@mpt-fo/common/kamona/components/kamona-progress-modal/kamona-progress-modal.component";
import {AppConfig} from "@mpt-fo/common/shared/config/app-config";
import {LoginHelperService} from "@mpt-fo/common/core/services/login-helper.service";
import {LocalStorageService} from "@mpt-fo/common/core/services/local-storage.service";
import {LivelinessService} from "@mpt-fo/common/core/services/liveliness.service";
import {AuthenticationService} from "@mpt-fo/common/core/services/authentication.service";
import {ProfileSetupService} from "@mpt-fo/common/core/services/profile-setup/profile-setup.service";
import { AuthenticationType2FA } from '@mpt-fo/common/shared/models/authentication-method.enum';
import { TwoFactorAuthenticationStartResponse } from '@mpt-fo/common/shared/models/two-factor-authentication.model';
import { Authentication2FAMixpanelSteps, AuthenticationEvents, DataLayerService } from '@mpt-fo/common/core/services/data-layer-service.service';
import { VerificationMethod } from '@app/channels/settings/settings/models/settings.model';
import { DeviceHelperService } from '@mpt-fo/common/core/services/device-helper.service';
import { LocationHelper } from '@mpt-fo/common/core/helpers/location.helper';

@Component({
  selector: 'ng-mf-app-forget-passcode',
  templateUrl: './forget-passcode.component.html',
  styleUrls: ['./forget-passcode.component.scss']
})
export class ForgetPasscodeComponent implements OnInit, OnDestroy {
	timelines = ForgetPasscodeTimelinesViaPhonenumber;
	usernameTimelines = ForgetPasscodeTimelinesViaUsername;
	currentStep: number;
	LoginTypeRequest = LoginTypeRequest;
	otpTimeline: TimelineModel;
	passcodeTimeline: TimelineModel;
	confirmPasscodeTimeline: TimelineModel;
	PasscodeRecoveryStep: any;
	CustomTimelineVersion = CustomTimelineVersion;
	isMobile: boolean;
	submitting: boolean;
	runningModal: NzModalRef;
	invalidPasscodeTitle = 'Invalid Passcode';
	invalidPasscodeMessage = 'New Passcode must be the same as confirm passcode';
	SubmittingDescription = 'Changing Passcode'
	SuccessTitle = 'Your Passcode Has Been Changed!';
	SuccessDescription = 'Your Passcode Has Been Changed successfully';
	ussdCode: string;
	PHONE_NUMBER_LOGIN_TYPE = 'PHONENUMBER';
	usePhoneNumberForRecovery: boolean;
	recoveryType = 'passcode';
	redirectUrl = '/login/forget-password';
	userTypePayload;
	livelinessRequired: boolean;
	processVerification: boolean;
	reference: string;
	flowId: string;
	provider: IdentityProvider;
	ID_VERIFICATION_URL = '/api/v1/settings/face-match';
	LIVELINESS_PURPOSE = 'PASSCODE_RESET';
	idVerificationUrl: string;
	verificationPayload: any;
	readonly LIVELINESS_REQUIRED_ERROR_CODE = '700006';
	msgTitle: string;
	msgDescription: string;
	suspensionReleaseTimeEpoch: number;
	showModal: boolean;
	iconType = IconType.INFO;
	btnText = 'Dismiss';
	btnType = BtnType.SECONDARY;
	readonly ID_VERIFICATION_SUSPENSION = '400209';
  verificationType = '';
  twoOrderByLiveliness = false;
  isLivelinessVerificationDone = false;
  twoFactorOrder = [];
  AuthenticationType = AuthenticationType2FA;
  otpPurpose = 'RECOVER_PASSCODE';
  loading = false;
  shouldGetNewReference: boolean;
  confirmingOtp = false;
  currentOtpModes = OtpResentMode;
  useResendOtpViaWhatsapp: boolean;
  useResendOtpViaSms: boolean;
  showBothCountDown = false;
  canUseNewUssd: boolean;
  currentOTPMode: OtpResentMode;
  hasResendButtonCountdown = false;

  constructor(
	  private screenManagerService: ScreenManagerService,
	  public settingsService: SettingsService,
	  public modalHelper: OnboardingV2Service,
	  private modalService: ModalService,
	  public config: AppConfig,
	  private loginHelper: LoginHelperService,
	  private localStorage: LocalStorageService,
	  private livelinessService: LivelinessService,
	  private authService: AuthenticationService,
	  private profileSetupService: ProfileSetupService,
		private deviceHelper: DeviceHelperService,
    private dataLayerService: DataLayerService,
		private locationHelper: LocationHelper,) { }

  ngOnInit(): void {
	  this.isMobile = this.screenManagerService.isMobile();
	  this.screenManagerService.isMobile$.subscribe((isMobile: boolean) => {
		  this.isMobile = isMobile;
	  });
  }

  initialize(){
    this.PasscodeRecoveryStep = PasscodeRecoveryStep;
	  this.userTypePayload = this.localStorage.getUserTypePayload();
	  this.usePhoneNumberForRecovery = this.isPhoneNumberLoginType();
	  if(!this.usePhoneNumberForRecovery) {
		  this.timelines = this.usernameTimelines;
	  }
	  this.startIdentityVerification();
  }

  startIdentityVerification(){
	  if(!this.userTypePayload?.hasEnteredIDCredential){return;}
	  this.setStepAfterEnteredIDCredential();
	  this.submitting = true;
    if (this.is2FAEnabled) {
      this.startResettingPasscode();
      return;
    }

	  this.generateOtp();
  }

  setStepAfterEnteredIDCredential(){
    this.otpTimeline = this.findTimelineByStep(this.PasscodeRecoveryStep.PHONE_VERIFICATION);
    this.setFirstStepValue();
	  this.setCurrentStep(this.PasscodeRecoveryStep.PHONE_VERIFICATION);
  }

  setFirstStepValue(){
    const value = this.userTypePayload?.value;
	  const params = this.usePhoneNumberForRecovery ? {phoneNumber: value} : {username: value};
	  this.updateTimelineWithFormData(params, PasscodeRecoveryStep.ENTER_PASSCODE_RECOVERY);
  }

  isPhoneNumberLoginType(){
	  return this.userTypePayload?.identityType === this.PHONE_NUMBER_LOGIN_TYPE;
  }

  setCurrentStep(step: number){
	this.currentStep = step;
  }

  submitPasscode(newPasscode: string, confirmPasscode: string){
	  this.isConfirmedPasscode(newPasscode, confirmPasscode)
	  ? this.handlePasscodeReset()
	  : this.handleInvalidPasscode();
  }

  isConfirmedPasscode(newPasscode: string, confirmPasscode: string){
		  return newPasscode === confirmPasscode;
  }


  handleInvalidPasscode(){
		  const title = this.invalidPasscodeTitle;
		  const description = this.invalidPasscodeMessage;
		  this.modalHelper.launchErrorModal({description, title});
  }

  handlePasscodeReset(){
	  this.submitting = true;
	  this.openInProgressModal();
	  const payload = this.is2FAEnabled ? this.buildPayloadToResetPasscodeV2() : this.buildPayloadToResetPasscode();
    const apiCall = this.is2FAEnabled ? this.settingsService.recoverPasscodeV2(payload) : this.settingsService.recoverPasscode(payload);
	  apiCall.then((res) => {this.handlePasscodeResponse(res?.message)})
		  .catch((error) => {this.handleFailedOtpGeneration(error);})
		  .finally(() => this.submitting = false);
  }

	 openInProgressModal(description?) {
	    if(!description){
			description = this.SubmittingDescription;
		}
		const config = this.createWebConfig(description);
		this.runningModal = this.modalService.createModal(KamonaProgressModalComponent, config);
	}

	private createWebConfig(description) {
		const config = new ModalOptionsConfig();
		config.nzMaskClosable = false;
		config.nzComponentParams.data = {description};
		config.className = HIDE_ANT_MODAL_CLASS;
		return config;
	}

  handlePasscodeResponse(message: string){}

  buildPayloadToResetPasscodeV2(): any {
    const deviceInformation = this.settingsService.getDeviceInformation();
    const timelineTimelineData = this.getTimelineDataByStep(PasscodeRecoveryStep.ENTER_PASSCODE_RECOVERY);
    const idTimelineData = this.getTimelineDataByStep(this.PasscodeRecoveryStep.PHONE_VERIFICATION);
    const idTimelineDataLiveliness2Fa = this.getTimelineDataByStep(this.PasscodeRecoveryStep.LIVELINESS);
    const passcodeTimelineData = this.getTimelineDataByStep(this.PasscodeRecoveryStep.ENTER_PASSCODE);
    const value = this.usePhoneNumberForRecovery ? timelineTimelineData?.phoneNumber : timelineTimelineData?.username;
    const passcode = passcodeTimelineData?.passcode;
    const twoFAPayloadLiveliness = this.shouldSendReference() ? { reference: idTimelineDataLiveliness2Fa?.validationKey || this.reference } : {}
    const payload = {
      newPasscode: passcode, otpValidationKey: this.ussdCode ? idTimelineData?.validationKey : null,
      authenticationPurpose: this.LIVELINESS_PURPOSE, ...twoFAPayloadLiveliness, deviceId: deviceInformation?.deviceUniqueIdentifier
    };
    return this.usePhoneNumberForRecovery ? { ...payload, phoneNumber: value } : { ...payload, username: value };
  }

  shouldSendReference(){
    return this.is2FAEnabled && this.isLivelinessVerificationDone && !!this.reference;
  }

  buildPayloadToResetPasscode(): any{
	  const timelineTimelineData = this.getTimelineDataByStep(PasscodeRecoveryStep.ENTER_PASSCODE_RECOVERY);
	  const idTimelineData = this.getTimelineDataByStep(PasscodeRecoveryStep.PHONE_VERIFICATION);
	  const passcodeTimelineData = this.getTimelineDataByStep(PasscodeRecoveryStep.ENTER_PASSCODE);
	  const value = this.usePhoneNumberForRecovery ? timelineTimelineData?.phoneNumber : timelineTimelineData?.username;
	  const passcode = passcodeTimelineData?.passcode;
	  const payload = {passcode, validationKey: idTimelineData?.validationKey};
	  return this.usePhoneNumberForRecovery ? {...payload, phoneNumber: value} : {...payload, username: value};
  }

  buildOtpGenerationPayload(): any{
	  const timelineData = this.getTimelineDataByStep(PasscodeRecoveryStep.ENTER_PASSCODE_RECOVERY);
	  const value = this.usePhoneNumberForRecovery ? timelineData?.phoneNumber : timelineData?.username;
	  return this.usePhoneNumberForRecovery ? {phoneNumber: value} : {username: value};
  }

  buildOtpGenerationPayload2FA(): any{
	  const timelineData = this.getTimelineDataByStep(PasscodeRecoveryStep.ENTER_PASSCODE_RECOVERY);
	  const value = this.usePhoneNumberForRecovery ? timelineData?.phoneNumber : timelineData?.username;
	  const payload = this.usePhoneNumberForRecovery ? {mobileNumber: value} : {username: value};
    return {...payload, authenticationPurpose: this.LIVELINESS_PURPOSE};
  }

	generateOtp()
	{
		this.submitting = true;
		this.settingsService.generateOtpForPasscodeRecovery(this.buildOtpGenerationPayload())
			.then((res) => {this.handleOtpGenerationResponse(res);})
			.catch((error)=> {this.handleFailedOtpGeneration(error)})
			.finally(() => this.submitting = false);
	}

  async startResettingPasscode() {
    this.submitting = true;
    const payload = this.buildOtpGenerationPayload2FA();

    try {
      const res: TwoFactorAuthenticationStartResponse = await this.settingsService.startUnAuthenticated(payload);
      this.handleStartResettingPasscodeResponse(res);
    } catch (error) {
      this.handleError(error);
    } finally {
      this.submitting = false;
    }
  }


  setOTPConfig() {
    const isWhatsAppEnabled = this.isWhatsAppEnabled;

    this.useResendOtpViaWhatsapp = isWhatsAppEnabled;
    this.useResendOtpViaSms = this.isSmsEnabled || !isWhatsAppEnabled;
    this.canUseNewUssd = false; // this.profileSetupService.canUseNewUssd();

    this.showBothCountDown = isWhatsAppEnabled && this.isSmsEnabled;
  }

	reloadOtp($event: OtpResentMode){
	  // New USSD && Whatsapp implementation
    if (this.is2FAEnabled) {
      this.currentOTPMode = $event;
      const isUssdResend = $event === OtpResentMode.USSD_MODE;
      isUssdResend ? this.handleResendOtpViaUssd()
        : this.generateOTP2FA();
        return;
    }
	  this.generateOtp();
	}

  handleResendOtpViaUssd() {
    this.setConfirmingOtp(true);
  }

  setConfirmingOtp(value: boolean) {
    this.confirmingOtp = value;
  }

	 handleRecovery(loginTypeRequest: LoginTypeRequest){
		this.submitting = true;
    this.submitting = true;
     if (this.is2FAEnabled) {
       this.startResettingPasscode();
       return;
     }
		this.handleCorrectLoginType(loginTypeRequest)
			.catch(error => {this.handleFailedOtpGeneration(error);})
			.finally(() => this.submitting = false);
	}

	async handleCorrectLoginType(identityType: LoginTypeRequest){
	    const otpPayload = this.buildOtpGenerationPayload();
		const value = this.usePhoneNumberForRecovery ? otpPayload?.phoneNumber : otpPayload?.username;
	    const payload = {identityType, value};
		const type = await this.authService.loginGetUserType(payload);
		const isCorrectRecovery = type?.loginType === this.recoveryType;
		isCorrectRecovery ? this.is2FAEnabled ? this.startResettingPasscode() : this.generateOtp() : this.handleInCorrectLoginType(payload);
	}

	handleInCorrectLoginType(payload){
		this.localStorage.saveUserTypePayload({...payload, hasEnteredIDCredential: true});
		this.modalHelper.routeToPage(this.redirectUrl);
	}

	validateOtp($event: any) {
		this.submitting = true;
    this.dataLayerService.logEventWithData(AuthenticationEvents.initiated, this.getEventData(null, Authentication2FAMixpanelSteps.VALIDATE_OTP_STARTED));
		this.settingsService.validateOtpForPasscodeRecovery(this.buildValidateOtpPayload( $event?.otp))
			.then((res) => {
        this.handleOtpValidationResponse(res?.validationKey, $event?.otp);
        this.dataLayerService.logEventWithData(AuthenticationEvents.success, this.getEventData(null, Authentication2FAMixpanelSteps.VALIDATE_OTP_SUCCESS));
      })
			.catch(error => {
        this.handleFailedOtpGeneration(error);
        this.dataLayerService.logEventWithData(AuthenticationEvents.failed, this.getEventData({
          errorCode: error?.error?.code,
          errorMessage: StringHelper.getErrorMessageHttpErrorResponse(error),
        }, Authentication2FAMixpanelSteps.VALIDATE_OTP_FAILED));
      })
			.finally(() => {this.submitting = false;})
	}

  async validateOtp2FA($event: any) {
    this.submitting = true;
    let payload = this.buildValidateOtpPayload($event?.otp);
    payload = { ...payload, authenticationPurpose: this.LIVELINESS_PURPOSE };

    this.dataLayerService.logEventWithData(
      AuthenticationEvents.initiated,
      this.getEventData(null, Authentication2FAMixpanelSteps.VALIDATE_OTP_STARTED)
    );

    try {
      const res = await this.settingsService.ValidateOtp2FA(payload);

      this.dataLayerService.logEventWithData(
        AuthenticationEvents.success,
        this.getEventData(null, Authentication2FAMixpanelSteps.VALIDATE_OTP_SUCCESS)
      );

      this.markasCompletedAndActiveTimeline(this.PasscodeRecoveryStep.PHONE_VERIFICATION + 1);
      this.handleOtpValidationResponse(res?.validationKey, $event?.otp);

    } catch (error) {
      this.dataLayerService.logEventWithData(
        AuthenticationEvents.failed,
        this.getEventData({
          errorCode: error?.error?.code,
          errorMessage: StringHelper.getErrorMessageHttpErrorResponse(error),
        }, Authentication2FAMixpanelSteps.VALIDATE_OTP_FAILED)
      );
      this.handleError(error);
    } finally {
      this.submitting = false;
    }
  }


	buildValidateOtpPayload(otp: string){
		let payload = this.buildOtpGenerationPayload();
		payload = {...payload, otp};
		return payload;
	}

  buildValidateOtpPayload2Fa(otp: string) {
    let payload = this.buildOtpGenerationPayload2FA();
    payload = { ...payload, otp };
    return payload;
  }

  handleOtpValidationResponse(validationKey: string, otp: string) {
    const data = { otp, validationKey };

    const nextKey = this.determineNextStep(data);
    this.updateTimeline(nextKey, data);
    this.setStepThreeTimeline();
    this.setCurrentStep(nextKey);
  }

  determineNextStep(data: any): PasscodeRecoveryStep {
    if (this.isUsing2FAFlow()) {
      return this.getNextKeyFor2FAFlow(data);
    } else {
      return this.getNextKeyWithout2FA(data);
    }
  }

  isUsing2FAFlow(): boolean {
    return this.is2FAEnabled && this.verificationType === AuthenticationType2FA.TWO_FACTOR_AUTHENTICATION;
  }

  getNextKeyFor2FAFlow(data: any): PasscodeRecoveryStep {
    const isOtpCompleted = this.isStepCompleted(this.PasscodeRecoveryStep.PHONE_VERIFICATION);

    if (this.isLivelinessVerificationDone) {
      return this.getNextKeyWhenLivelinessDone(data, isOtpCompleted);
    } else {
      this.updateTimelineWithFormData(data, this.PasscodeRecoveryStep.PHONE_VERIFICATION);
      return this.PasscodeRecoveryStep.LIVELINESS;
    }
  }

  getNextKeyWhenLivelinessDone(data: any, isOtpCompleted: boolean): PasscodeRecoveryStep {
    const nextKey = isOtpCompleted ? this.PasscodeRecoveryStep.ENTER_PASSCODE : this.PasscodeRecoveryStep.PHONE_VERIFICATION;
    this.updateTimelineWithFormData(data, nextKey - 1);
    return nextKey;
  }

  getNextKeyWithout2FA(data: any): PasscodeRecoveryStep {
    this.updateTimelineWithFormData(data, PasscodeRecoveryStep.PHONE_VERIFICATION);
    return PasscodeRecoveryStep.ENTER_PASSCODE;
  }

  updateTimeline(nextKey: PasscodeRecoveryStep, data: any): void {
    if (!this.reference || !this.ussdCode) {
      this.generate2FA();
    }

    if (this.is2FAEnabled) {
      this.markasCompletedAndActiveTimeline(nextKey);
    } else {
      this.updateOtpTimeline();
    }
  }

  isStepCompleted(step) {
    return this.timelines.find(timeline => timeline.step === step).state == "completed";
  }

  markasCompletedAndActiveTimeline(nextKey) {
    this.timelines.forEach(element => {
      if (element.step < nextKey) {
        element.state = 'completed';
        element.isStepCompleted = true;
      } else if (element.step == nextKey) {
        element.state = 'active';
      } else {
        element.state = 'inactive';
      }
    });
  }

	setStepThreeTimeline(){
		this.passcodeTimeline = this.settingsService.findTimelineByStep(this.timelines, this.PasscodeRecoveryStep.ENTER_PASSCODE);
	}

	updateOtpTimeline(){
		this.settingsService.markTimelineAsCompleted(this.timelines, this.PasscodeRecoveryStep.PHONE_VERIFICATION);
		this.settingsService.markNextTimelineAsActive(this.timelines, this.PasscodeRecoveryStep.ENTER_PASSCODE);
	}



	goToLogin(){
	  this.modalHelper.login();
	}

	restart(){
	  const RESTART_STEP = 1;
	  this.settingsService.resetTimeline(this.timelines);
	  this.setCurrentStep(RESTART_STEP);
	}

	dismiss(){
	  this.goToLogin();
	}

	handleFailedOtpGeneration(error: any){
	  const livelinessRequired = this.isLivelinessRequired(error);
	  if(livelinessRequired){
		 this.handleLivelinessRequired(error)
		  return;
	  }
	  this.handleLivelinessNotRequiredError(error);
	}

	handleLivelinessNotRequiredError(error){
		const params = this.getErrorParameters(error);
		if(this.isSuspendedFromLiveliness(error?.error)){
			this.handleLivelinessSuspension({...error?.error, description: params?.description});
			return;
		}
		this.launchFailedModal(params?.description, params?.title, params?.callbackName);
	}

  handleError(error) {
    const params = this.getErrorParameters(error);
    this.launchFailedModal(params?.description, params?.title, params?.callbackName);
  }

	updateIdVerificationTimelineWithLiveliness(){
		this.timelines.forEach( timeline => {
			if(timeline.step === this.PasscodeRecoveryStep.PHONE_VERIFICATION){
				timeline.title = 'Verify ID Information';
			}
		})
	}

	getErrorParameters(error){
		const title = this.getFailedOtpGenerationTitle(error);
		const callbackName = this.getFailedOtpGenerationCallbackName(error);
		const description = StringHelper.getErrorMessageHttpErrorResponse(error);
		return {title, callbackName, description};
	}

	handleLivelinessRequired(error:any){
		this.updateIdVerificationTimelineWithLiveliness();
	    this.setLivelinessParameters(error);
		this.proceedToLiveliness();
	}

	proceedToLiveliness(){
		this.setCurrentStep(this.PasscodeRecoveryStep?.PHONE_VERIFICATION);
	}

	setLivelinessParameters(error: any){
		const params = error?.error;
		this.provider = params?.provider;
		this.reference = params?.reference;
		this.flowId = params?.flowId;
		this.livelinessRequired = true;
	}

	isLivelinessRequired(error: any){
	  const errorCode = error?.code || error?.error?.responseCode
	  const isLivelinessRequired = errorCode === this.LIVELINESS_REQUIRED_ERROR_CODE;
	  return isLivelinessRequired;
	}

	launchFailedModal(description, title, callbackName){
		this.modalHelper.launchErrorModalV2({description, callbackName, title})
			.then(() =>{
				this.modalHelper.closeModal();
				this.settingsService.resetTimeline(this.timelines);
				this.setCurrentStep(PasscodeRecoveryStep.ENTER_PASSCODE_RECOVERY);
        this.reference = null;
        this.ussdCode = null;
        this.isLivelinessVerificationDone = false;
        this.currentOTPMode = null;
			})
	}

	getFailedOtpGenerationTitle(error: any){
		const title = this.modalHelper.isSuspended(error) ?
		'Temporary Suspension': ''
		return title;
	}


	getFailedOtpGenerationCallbackName(error: any){
		const callbackName = this.modalHelper.isSuspended(error) ? 'Dismiss': ''
		return callbackName;
	}

	handleOtpGenerationResponse(res: any){
	  this.ussdCode = res?.ussdCode
	  this.otpTimeline = this.settingsService.findTimelineByStep(this.timelines, this.PasscodeRecoveryStep.PHONE_VERIFICATION);
	  this.otpTimeline.title = 'Verify OTP';
	  this.setCurrentStep(this.PasscodeRecoveryStep.PHONE_VERIFICATION);
	}

  handleStartResettingPasscodeResponse(res: TwoFactorAuthenticationStartResponse) {
    this.setOTPConfig();
    this.verificationType = res.authenticationMethod;
    this.dataLayerService.logEventWithData(AuthenticationEvents.initiated, this.getEventData());
    if (this.verificationType !== AuthenticationType2FA.TWO_FACTOR_AUTHENTICATION) {
      this.twoFactorOrder = [res.authenticationMethod]
    } else {
      this.twoFactorOrder = res.order;
    }
    this.setTimeline(res);
  }


  setTimeline(res: TwoFactorAuthenticationStartResponse) {
    this.twoOrderByLiveliness = res.order ? res.order[0] == AuthenticationType2FA.FACE_MATCH : false;

    if (!this.is2FAEnabled) {
      this.generateOtp();
      return;
    }

    if (this.verificationType !== AuthenticationType2FA.TWO_FACTOR_AUTHENTICATION) {
      this.handleNon2FATimeline();
      return;
    }

    this.setRecoveryTimelines();
    this.setFirstStepValue();
    this.generate2FA();
  }

  handleNon2FATimeline() {
    this.setCurrentStep(this.PasscodeRecoveryStep.PHONE_VERIFICATION);
    if (this.verificationType === AuthenticationType2FA.FACE_MATCH) {
      this.updateIdVerificationTimelineWithLiveliness();
    }
    this.generate2FA();
  }

  setRecoveryTimelines() {
    if (this.usePhoneNumberForRecovery) {
      this.setPhoneNumberRecoveryTimelines();
    } else {
      this.setUsernameRecoveryTimelines();
    }
  }

  async generate2FA() {
    this.submitting = true;
    try {
      for (const method of this.twoFactorOrder) {
        if (method === AuthenticationType2FA.FACE_MATCH && !this.reference) {
          await this.generateReference2FA();
          break;
        } else if (method === AuthenticationType2FA.OTP && !this.ussdCode) {
          await this.generateOTP2FA();
          break;
        }

      }
    } catch (error) {
      this.handleError(error);
    } finally {
      this.submitting = false;
    }
  }

	getDeviceInformation(){
		return this.deviceHelper.getDeviceInformation();
	}

  async generateReference2FA() {
    this.submitting = true;
    this.loading = true;
    let payload = this.buildOtpGenerationPayload2FA();
    const deviceInformation = this.getDeviceInformation();

    payload = { 
			...payload, 
			livenessPurpose: this.LIVELINESS_PURPOSE,
			deviceUniqueIdentifier: deviceInformation?.deviceUniqueIdentifier
		};
    this.dataLayerService.logEventWithData(AuthenticationEvents.initiated, this.getEventData(null, Authentication2FAMixpanelSteps.INITIATE_FACE_MATCH_STARTED));
    this.settingsService.generateReference2FA(payload)
      .then((res) => {
        this.setLivelinessParameters2fa(res);
        this.dataLayerService.logEventWithData(AuthenticationEvents.success, this.getEventData(null, Authentication2FAMixpanelSteps.INITIATE_FACE_MATCH_SUCCESS));
      })
      .catch((error) => {
        this.dataLayerService.logEventWithData(AuthenticationEvents.failed, this.getEventData({
          errorCode: error?.error?.code,
          errorMessage: StringHelper.getErrorMessageHttpErrorResponse(error),
        }, Authentication2FAMixpanelSteps.INITIATE_FACE_MATCH_FAILED));
        this.handleError(error);
      })
      .finally(() => {
        this.submitting = false;
        this.loading = false;
      });
  }

  setLivelinessParameters2fa(params: any) {
    this.provider = params?.provider;
    this.reference = params?.reference;
    this.flowId = params?.flowId;
    this.livelinessRequired = true;
  }


  async generateOTP2FA() {
    this.submitting = true;
    this.loading = true;
    this.livelinessRequired = false;
    const payload = this.buildOtpGenerationPayload2FA();
    payload['notificationChannel'] = (this.currentOTPMode || OtpResentMode.SMS_MODE)?.split('_')[0];
    this.dataLayerService.logEventWithData(AuthenticationEvents.initiated, this.getEventData(null, Authentication2FAMixpanelSteps.GENERATE_OTP_STARTED));
    this.settingsService.generateOtp2FAPublic(payload, this.otpPurpose)
      .then((res) => {
        if(this.useResendOtpViaWhatsapp && !this.useResendOtpViaSms){
          this.currentOTPMode = OtpResentMode.WHATSAPP_MODE;
        }
        this.ussdCode = res?.ussdCode;
        this.otpTimeline = this.settingsService.findTimelineByStep(this.timelines, this.PasscodeRecoveryStep.PHONE_VERIFICATION);
        this.otpTimeline.title = 'Verify OTP';
        this.otpTimeline.description = res?.otpMessage;
        this.dataLayerService.logEventWithData(AuthenticationEvents.success, this.getEventData(null, Authentication2FAMixpanelSteps.GENERATE_OTP_SUCCESS));
      })
      .catch((error) => {
        this.dataLayerService.logEventWithData(AuthenticationEvents.failed, this.getEventData({
          errorCode: error?.error?.code,
          errorMessage: StringHelper.getErrorMessageHttpErrorResponse(error),
        }, Authentication2FAMixpanelSteps.GENERATE_OTP_FAILED));
        this.handleError(error);
      })
      .finally(() => {
        this.submitting = false;
        this.loading = false;
      });
  }

  setPhoneNumberRecoveryTimelines() {
    if (this.twoOrderByLiveliness) {
      this.setTimelinesAndSteps(ForgetPasscodeTimelinesViaPhonenumber2FAOrderByLiveliness, PasscodeRecoveryStep2FAOrderByLiveliness, PasscodeRecoveryStep2FAOrderByLiveliness.LIVELINESS);
    } else {
      this.setTimelinesAndSteps(ForgetPasscodeTimelinesViaPhonenumber2FAOrderByOTP, PasscodeRecoveryStep2FAOrderByOTP, PasscodeRecoveryStep2FAOrderByOTP.PHONE_VERIFICATION);
    }
  }

  setUsernameRecoveryTimelines() {
    if (this.twoOrderByLiveliness) {
      this.setTimelinesAndSteps(ForgetPasscodeTimelinesViaUsername2FAOrderByLiveliness, PasscodeRecoveryStep2FAOrderByLiveliness, PasscodeRecoveryStep2FAOrderByLiveliness.LIVELINESS);
    } else {
      this.setTimelinesAndSteps(ForgetPasscodeTimelinesViaUsername2FAOrderByOTP, PasscodeRecoveryStep2FAOrderByOTP, PasscodeRecoveryStep2FAOrderByOTP.PHONE_VERIFICATION);
    }
  }

  setTimelinesAndSteps(timelines: any, passcodeRecoveryStep: any, currentStep: any) {
    this.timelines = timelines;
    this.PasscodeRecoveryStep = passcodeRecoveryStep;
    this.setCurrentStep(currentStep);
    this.markasCompletedAndActiveTimeline(currentStep);
  }


	submitPasscodeWeb({newPasscode, confirmPasscode}){
		const passcodeData = {passcode: newPasscode};
		const confirmPasscodeData = {confirmPasscode};
		this.updateTimelineWithFormData(passcodeData, this.PasscodeRecoveryStep.ENTER_PASSCODE);
		this.updateTimelineWithFormData(confirmPasscodeData, this.PasscodeRecoveryStep.CONFIRM_PASSCODE);
		this.handleConfirmedPassCodeTimeline();
		this.submitPasscode(newPasscode, confirmPasscode);
	}

	handleConfirmedPassCodeTimeline(){
		this.updatePassCodeTimeline();
		this.updateConfirmPassCodeTimeline();
	}



	submitConfirmedPasscode($event: string){
		const data = {confirmPasscode: $event};
		this.updateTimelineWithFormData(data, this.PasscodeRecoveryStep.CONFIRM_PASSCODE);
		const newPasscodeKey = this.PasscodeRecoveryStep.ENTER_PASSCODE;
		const newPasscode = this.getTimelineDataByStep(newPasscodeKey)?.passcode;
		this.updateConfirmPassCodeTimeline();
		this.submitPasscode(newPasscode, $event);
	}

	updateTimelineWithFormData(data: any, step:number){
		const timeline = this.settingsService.findTimelineByStep(this.timelines, step);
		if(timeline){timeline.data = data;}
	}

	getTimelineDataByStep(step: number){
	  const timeline = this.findTimelineByStep(step);
	  return timeline?.data;
	}

	findTimelineByStep(step: number){
		return this.settingsService.findTimelineByStep(this.timelines, step);
	}

	setPasscode($event: string){
		const data = {passcode: $event}
		this.updateTimelineWithFormData(data,this.PasscodeRecoveryStep.ENTER_PASSCODE);
		this.updateEnterPassCodeTimeline();
		this.setConfirmPasscodeTimeline();
		this.setCurrentStep(this.PasscodeRecoveryStep.CONFIRM_PASSCODE);
	}

	setConfirmPasscodeTimeline(){
		this.confirmPasscodeTimeline = this.settingsService.findTimelineByStep(this.timelines, this.PasscodeRecoveryStep.CONFIRM_PASSCODE);
	}

	updateEnterPassCodeTimeline(){
		this.updatePassCodeTimeline();
		this.settingsService.markNextTimelineAsActive(this.timelines, this.PasscodeRecoveryStep.CONFIRM_PASSCODE);
	}

	updatePassCodeTimeline(){
		this.settingsService.markTimelineAsCompleted(this.timelines, this.PasscodeRecoveryStep.ENTER_PASSCODE);
	}

	updateConfirmPassCodeTimeline(){
		this.settingsService.markTimelineAsCompleted(this.timelines, this.PasscodeRecoveryStep.CONFIRM_PASSCODE);
	}

	handleOtpResponse($event:{otp: string}){
    if (this.is2FAEnabled) {
      this.validateOtp2FA($event);
    } else {
      this.validateOtp($event);
    }
	}

	signUp() {
		if(this.profileSetupService.useProfileSetup()){
			this.modalHelper.routeToPage('/onboarding-v2/profile-setup');
			return;
		}
		const route = '/onboarding/create-account';
		const canUseNewOnboardingFlow = this.config.USE_NEW_SIGN_UP_FLOW || this.config.SHOW_SIGN_UP_PASSCODE_FLOW;
		canUseNewOnboardingFlow ? this.signUpToNewOnboardingFlow()
		: this.modalHelper.routeToPage('/onboarding/create-account');
	}

	signUpToNewOnboardingFlow() {
		this.loginHelper.initializeSignup();
		this.modalHelper.routeToPage('/onboarding-v2');
	}

	submitSmileIDJob($event: SmileIdImage []){
	  this.openInProgressModal('Submitting liveliness');
	  const payload = this.buildSmileIDJobPayload($event);
	  this.livelinessService.submitSmileIDJob(payload)
		  .then(() => {
			 this.handleSmileIDJobResponse();
       this.dataLayerService.logEventWithData(AuthenticationEvents.initiated, this.getEventData(null, Authentication2FAMixpanelSteps.VALIDATE_FACE_MATCH_STARTED));
		  }).finally(() => this.submitting = false)
		  .catch(error => {
			  this.handleSmileIDJobFailure(error);
		  })
	}

	handleFinishedMetaMapVerification(){
		this.idVerificationUrl = this.verificationUrl();
		this.setVerificationPayload();
		this.processVerification = true;
	}

	handleFailedIdentity({message, shouldGetNewReference}){
    this.dataLayerService.logEventWithData(AuthenticationEvents.failed, this.getEventData({
      errorMessage: message
    }, Authentication2FAMixpanelSteps.VALIDATE_FACE_MATCH_FAILED));
    this.shouldGetNewReference = shouldGetNewReference;
	  this.processVerification = false;
	  this.setFailedLivelinessMessageParameter(message);
	}

	setFailedLivelinessMessageParameter(description: string){
	  this.msgTitle = 'Identity Not Verified';
	  this.iconType = IconType.ERROR;
	  this.btnType = BtnType.PRIMARY;
	  this.btnText = 'Try again'
	  this.msgDescription = description ?? 'We have not been able to verify your identity';
	  this.showModal = true;
	}

	handleLivelinessSuspension(params: any){
		this.msgDescription = params?.description;
		this.msgTitle = 'Too Many Failed Attempts';
		this.btnType = BtnType.SECONDARY;
		this.btnText = 'Dismiss';
		this.suspensionReleaseTimeEpoch  = params?.suspensionReleaseTimeEpoch ?? new Date(params?.suspensionReleaseTime)?.getTime();
		this.modalHelper.closeModal();
		this.restart()
		this.showModal = true;
	}


	isSuspendedFromLiveliness(params : any){
		const code = params?.code ?? params?.responseCode;
		return code === this.ID_VERIFICATION_SUSPENSION;
	}

	setVerifiedLivelinessMessageParameter(){
		this.msgTitle = 'Identity Verified';
		this.iconType = IconType.SUCCESS;
		this.btnType = BtnType.PRIMARY;
		this.btnText = 'Continue'
		this.msgDescription = 'Identity verified successfully';
		this.showModal = true;
	}

	handleCloseModal(){
		this.suspensionReleaseTimeEpoch = 0;
		this.showModal = false;
    if(this.shouldGetNewReference)
      this.restartStep();
	}

  restartStep() {
    this.reference = null;
    this.ussdCode = null;
    this.isLivelinessVerificationDone = false;
    this.processVerification = false;
    this.shouldGetNewReference = false;
    const RESTART_STEP = 1;
    this.settingsService.resetTimeline(this.timelines);
    this.setCurrentStep(RESTART_STEP);
    this.restartProcessFromStart();
  }

  restartProcessFromStart(){
    this.startIdentityVerification();
  }



	handleVerifiedIdentity({reference}){
    this.dataLayerService.logEventWithData(AuthenticationEvents.success, this.getEventData(null, Authentication2FAMixpanelSteps.VALIDATE_FACE_MATCH_SUCCESS));
		this.processVerification = false;
    this.isLivelinessVerificationDone = true;
		this.setVerifiedLivelinessMessageParameter();
		this.handleOtpValidationResponse(reference || this.reference, null);
    }

	handleSmileIDJobFailure(error){
	  const params = this.getErrorParameters(error);
	  this.modalHelper.closeModal();
	  this.launchFailedModal(params?.description, params?.title, params?.callbackName);
	}

  verificationUrl(){
    return `${this.config.MONIEPOINT_USER_URL}${this.ID_VERIFICATION_URL}/${this.reference}/status?livenessPurpose=${this.LIVELINESS_PURPOSE}`;
  }

	handleSmileIDJobResponse(){
	  this.idVerificationUrl = this.verificationUrl();
	  this.setVerificationPayload();
	  this.modalHelper.closeModal();
	  this.processVerification = true;
	}

	setVerificationPayload(){
	  const value = this.getIdVerificationPayloadValue();
	  const params = this.usePhoneNumberForRecovery ?
	  {phoneNumber: value}
	  : {username: value};
	  this.verificationPayload = params;
	}

	getIdVerificationPayloadValue(){
		const timelineData = this.getTimelineDataByStep(PasscodeRecoveryStep.ENTER_PASSCODE_RECOVERY);
		const value = this.usePhoneNumberForRecovery ? timelineData?.phoneNumber : timelineData?.username;
		return value;
	}

	buildSmileIDJobPayload($event: SmileIdImage []): SmileIdPayload{
	  return {
		  reference: this.reference,
		  images: $event
	  }
	}

  get is2FAEnabled() {
    return this.config.USE_2FA_FLOW_FORGOT_PASSCODE;
  }

  get isWhatsAppEnabled() {
    return this.config.USE_OTP_WHATSAPP_FORGOT_PASSCODE;
  }

  get isSmsEnabled() {
    return this.config.SEND_SMS_OTP_2FA;
  }

	async getEventData(errorDetails?: { errorCode?: string; errorMessage: string; }, step = '') {
		const geoHeaders = await this.locationHelper.getCoordinates();

		return {
			auth_type: this.verificationType,
			auth_type_provider: this.getAuthTypeProvider(),
			feature: this.LIVELINESS_PURPOSE,
      step: step,
			...(geoHeaders ? {
				longitude: geoHeaders.longitude,
				latitude: geoHeaders.latitude,
			} : {}),
      ...(errorDetails ? {
				api_error_code: errorDetails.errorCode,
				api_error_message: errorDetails.errorMessage,
        error_message: errorDetails.errorMessage,
			} : {}),
		};
	}

  getAuthTypeProvider() {
    if (!this.isLivelinessVerificationDone) {
      return (this.verificationType === VerificationMethod.OTP ? '' : this.provider)
    }
    return '';
  }

  isTwoFactorAuthentication(): boolean {
    return this.verificationType === AuthenticationType2FA.TWO_FACTOR_AUTHENTICATION;
  }

	ngOnDestroy(): void {
		this.settingsService.resetTimeline(this.timelines);
	}

}
